export enum LoggerUpdateFirmwareState {
  Planned = 'PLANNED',
  PlannedExtern = 'PLANNED_EXTERN',
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS',
  Downloaded = 'DOWNLOADED',
  Verified = 'VERIFIED',
}
